import { InjectionToken } from '@angular/core';

const ABSTRACT_DATA = new InjectionToken<any>('Abstract Data');

export {
  ABSTRACT_DATA
};
